import { PlacementPositions } from "../../../../enums/PlacementPositionsEnums";

export const InvoiceFilterConstants = {
  DRAWER: {
    MASK_CLOSABLE: false,
    DESTROY_ON_CLOSE: true,
    CLOSABLE: true,
    MASK: true,
    GET_CONTAINER: false,
    PLACEMENT: PlacementPositions.RIGHT,
    WIDTH: "36rem",
    HEIGHT: "100vh",
    SIZE: "large",
    TITLE: "Filter",
  },
  FOOTER: {
    CANCEL_BUTTON_LABEL: "Cancel",
    APPLY_BUTTON_LABEL: "Apply",
    CLEAR_BUTTON_LABEL: "Clear Filters",
  },
};
